{
  "meta": {
    "home": {
      "title": "BYHOURS: Buchen Sie in mehr als 4.000 Hotels stundenweise",
      "description": "Genieße ein Hotel für ein paar Stunden zum Ausruhen, Arbeiten, Abschalten und zum Erleben. Du zahlst nur für die Zeit, die du wirklich benötigst. Unsere Tageszimmer sind in Stundenpaketen von 3, 6 oder 24 verfügbar, tagsüber und nachts. Microstays macht es möglich! Gratis Stornierung bis 24h vor Check-in!",
      "keywords": "byhours, Hotelstunden, microstays, stundenweise Hotels, stundenweise, sparen, buchen, Hotels, Hotels in Barcelona, Hotels in London, Hotels in Frankfurt, Hotels in Berlin, stundenweise Hotels in Barcelona, stundenweise Hotels in Frankfurt, stundenweise Hotels in Dusseldorf, stundenweise Hotels in London, stundenweise Hotels in Berlin, stundenweise Hotels in München, tageszimmer Berlin, tageszimmer Potsdam, tageszimmer München, tageszimmer Frankfurt, tageshotel berlin, tageshotel München, tageshotel potsdam, tageshotel frankfurt, zimmer stundenweise, Hotels stundenweise, tageshotel, tages hotel, zimmer für Stunden, zimmer für ein paar stunden, byhours erfahrungen, Hotel tagsüber, dayuse, daybreak"
    },
    "search": {
      "title": "Hotels stundenweise in {city_name}",
      "description": "Die besten Hotels in {city_name} stundenweise in Paketen von 3, 6 und 24 Stunden. Für Tag und Nacht mit Zugang zu allen Hoteleinrichtungen. Kostenlose Stornierung und flexibles Einchecken.",
      "keywords": "byhours, byhours {city_name}, stundenweise Hotels in {city_name}, Hotelstunden {city_name}, microstays {city_name}, stundenweise Zimmer {city_name}, Hotels nach Stunden {city_name}, stundenweise Hotelbuchungen {city_name},{city_name}"
    },
    "detail": {
      "title": "{hotel_name} {city_name} für 3, 6 oder 24 Stunden",
      "description": "Genießen Sie ein paar freie Stunden im {hotel_name} in {city_name} und zahlen Sie nur für die Zeit, die Sie benötigen. Wählen Sie die Check-in-Zeit, die Ihnen am besten passt, und genießen Sie alle Einrichtungen. {hotel_description}",
      "keywords": "byhours {hotel_name}, by hours {hotel_name}, buyhours, {hotel_name}, Stundenweise {hotel_name}, Hotelstunden {hotl_name}, microstays {hotel_name}, stundenweise Zimmer {hotel_name}, Hotels nach Stunden {hotel_name}, stundenweise Hotelbuchungen {hotel_name}, {hotel_name}"
    },
    "landing": {
      "title": "Hotels stundenweise in {city_name}",
      "description": "Die besten Hotels in {city_name} stundenweise in Paketen von 3, 6 und 24 Stunden. Für Tag und Nacht mit Zugang zu allen Hoteleinrichtungen. Kostenlose Stornierung und flexibles Einchecken.",
      "keywords": "byhours, byhours {city_name}, stundenweise Hotels in {city_name}, Hotelstunden {city_name}, microstays {city_name}, stundenweise Zimmer {city_name}, Hotels nach Stunden {city_name}, stundenweise Hotelbuchungen {city_name},{city_name}"
    },
    "como-funciona": {
      "title": "So buchen Sie Hotels stundenweise: Schritt für Schritt",
      "description": "Erfahren Sie, wie Sie in nur 4 einfachen Schritten 3, 6 oder 24 Stunden in einem Hotel in über 600 Reisezielen genießen können.",
      "keywords": "Zweifel, Schritte, wie man bucht, byhours, Hotels stundenweise"
    },
    "byhours-destinations": {
      "title": "Buchen Sie in mehr als 600 Zielen",
      "description": "Buchen Sie stundenweise Zimmer in Ihrem Lieblingshotel und bestimmen Sie die Check-in-Zeit. Wählen Sie aus über 4.000 3-, 4- und 5-Sterne-Hotels und buchen Sie in über 600 Destinationen. Zugang zu allen Hoteldienstleistungen mit kostenloser Stornierung. Buchen Sie jetzt bei BYHOURS, dem Marktführer für Microstays.",
      "keywords": "ziele, byhours, hotels"
    },
    "privacy": {
      "title": "Datenschutzrichtlinie",
      "description": "Datenschutz und Datenschutzrichtlinie von BYHOURS. Informationen zur Verarbeitung Ihrer personenbezogenen Daten bei der Nutzung unserer Buchungsdienste für Hotels auf Stundenbasis."
    },
    "terms": {
      "title": "Allgemeine Geschäftsbedingungen",
      "description": "Nutzungsbedingungen des BYHOURS-Services. Bedingungen für die Buchung von Hotelzimmern auf Stundenbasis in über 4.000 Hotels."
    },
    "onDemand": {
      "title": "BYHOURS On Demand — Verfügbarkeitsanfrage",
      "description": "Sagen Sie uns, was Sie brauchen – unser Team hilft Ihnen, Verfügbarkeit auf Anfrage zu finden."
    },
    "hoteliers": {
      "title": "BYHOURS für Hoteliers — Leere Stunden in Umsatz verwandeln",
      "description": "Verkaufen Sie Mikroaufenthalte in 3-, 6- und 24-Stunden-Fenstern nach Ihren Regeln: Preis, Verfügbarkeit und eigener Kanal. Ohne Mindestkontingent.",
      "ogTitle": "BYHOURS für Hotelier",
      "ogDescription": "Monetarisieren Sie Leerstände mit Mikroaufenthalten und voller Kontrolle über die Extranet-Oberfläche."
    }
  },
  "stickyBookingBar": {
    "reservarAhora": "Jetzt buchen",
    "elegirHora": "Uhrzeit wählen",
    "aria": "Schnelle Buchungsleiste"
  },
  "roomCard": {
    "badges": {
      "freeCancellation": "Kostenlose Stornierung bis 24h",
      "payNow": "Jetzt bezahlen",
      "payAtDestination": "Zahlung vor Ort"
    },
    "packWindow": {
      "allDay": "Ganzer Tag"
    },
    "packOption": {
      "hours": "{count} Stunden",
      "vatIncluded": "MwSt. inbegriffen",
      "availabilityTitle": "Verfügbarkeit",
      "extraHourPromo": "Inklusive 1 extra Stunde Aufenthalt"
    },
    "realPrice": {
      "taxesIncluded": "Steuern und Gebühren inklusive",
      "taxesNotIncluded": "Steuern und Gebühren nicht inklusive",
      "taxesBreakdown": "Aufschlüsselung von Steuern und Gebühren"
    },
    "reserve": "Buchen"
  },
  "searchCard": {
    "urgency": {
      "oneRoom": "Noch 1 Zimmer",
      "moreRooms": "Noch {count} Zimmer"
    },
    "viewRooms": "Zimmer ansehen",
    "availablePacks": {
      "one": "Aufenthalt {pack}h",
      "many": "Aufenthalte {packs}"
    },
    "promos": {
      "multiple": "{count} Aktionen",
      "modalTitle": "Verfügbare Aktionen"
    }
  },
  "buttons": {
    "borrar": "Löschen",
    "reiniciar": "Zurücksetzen",
    "aplicar": "Anwenden",
    "cerrar": "Schließen",
    "filtros": "Filter",
    "buscar": "Suchen",
    "cargando": "Laden",
    "mapa": "Weltkarte",
    "buscarZona": "In dieser Zone suchen",
    "filtroEntrada": "Check-in-Zeit",
    "eligeHorario": "Wähle deine Zeiten",
    "continuar": "Weiter",
    "continuarSinExtras": "Weiter ohne Extras",
    "cancel": "Abbrechen",
    "buscarDia": "Anderen Tag suchen",
    "buscarOtroHotel": "Anderes Hotel suchen",
    "noDispo": "Keine Verfügbarkeit",
    "dispo": "Ankunftszeit",
    "dispoOtrosDias": "An anderen Tagen verfügbar",
    "moreImg": "Mehr Bilder",
    "readMore": "Mehr lesen",
    "readLess": "Weniger lesen",
    "reservar": "Buchen",
    "cancelBook": "Buchung stornieren",
    "modifyBook": "Buchung ändern",
    "repeatBook": "Buchung wiederholen",
    "deleteBook": "Buchung löschen",
    "clearHistory": "Verlauf löschen",
    "desde": "Ab",
    "todos": "Alle",
    "login": "Anmelden",
    "verMapa": "Karte ansehen",
    "compartir": "Teilen",
    "guardar": "Speichern",
    "guardado": "Gespeichert"
  },
  "labels": {
    "hoy": "Heute",
    "mañana": "Morgen",
    "dia": "Tag",
    "dateRangeShortMinus1": "- 1 Tag",
    "dateRangeShortPlus1": "+ 1 Tag",
    "dateRangeShortBoth": "± 1 Tag",
    "dateRangeMinus1": "Einen Tag davor suchen",
    "dateRangePlus1": "Einen Tag danach suchen",
    "dateRangeBoth": "Einen Tag davor und danach suchen",
    "dateRangeSelector": "Suche auf nahe Tage erweitern",
    "horas": "Stunden",
    "hoteles": "Hotels",
    "todoDia": "Den ganzen Tag",
    "searchDestino": "Übereinstimmende Ziele",
    "destinosPopulares": "Beliebte Ziele",
    "busquedasRecientes": "Letzte Suchanfragen",
    "placeholderDestino": "Nach einem Ziel suchen...",
    "ubicacion": "Standort",
    "rooms": "Zimmer",
    "pack": "Stundenpaket",
    "entrada": "Check-in",
    "horarioReserva": "Buchungszeiten",
    "salida": "Ausgang",
    "nombre": "Name",
    "apellido": "Nachname",
    "ciudad": "Stadt",
    "telefono": "Telefon",
    "extras": "Gebuchte Extras",
    "password": "Aktuelles Passwort",
    "newPassword": "Neues Passwort",
    "repeatPassword": "Neues Passwort wiederholen",
    "passwordRequirements": {
      "length": "Mindestens 8 Zeichen",
      "uppercase": "Mindestens 1 Großbuchstabe",
      "lowercase": "Mindestens 1 Kleinbuchstabe",
      "number": "Mindestens 1 Zahl"
    },
    "email": "E-Mail",
    "detalle": "Details",
    "pago": "Zahlungsdaten",
    "pagado": "Bezahlt",
    "total": "Gesamt",
    "changePassword": "Passwort ändern",
    "precioHab": "pro Zimmer",
    "errorHora": "Wähle deine Check-in-Zeit",
    "errorHotel": "Wir haben das Hotel nicht gefunden",
    "errorDestino": "Ziel nicht gefunden",
    "errorPaginaNoEncontrada": "Seite nicht gefunden",
    "errorPaginaNoEncontradaSubtitle": "Die Seite, die Sie suchen, existiert nicht.",
    "verHoteles": "Hotels in {city_name} sehen",
    "verHotelesDisponibles": "Siehe die {count} verfügbaren Hotels in {city_name}",
    "destacados": "Ausgewählte Hotels in {city_name}",
    "reserva": "Buchen Sie Ihr Hotel stundenweise",
    "descubre": "Entdecken Sie Hotels in {city_name}",
    "hero": {
      "entradaFlexible": "Flexibler Check-in",
      "hotelesVerificados": "Geprüfte Hotels",
      "sinNocheMinima": "Keine Mindestübernachtung"
    },
    "comoFunciona": "Wie funktioniert es?",
    "errorResultado": "Upps... Wir haben nichts gefunden, was Ihrer Suche entspricht.",
    "errorResultadoTitle": "Keine Ergebnisse",
    "destinos": "Ziele",
    "selectDestino": "Wählen Sie ein Land",
    "ubicacionActual": "Aktueller Standort",
    "zonaActual": "Ausgewählter Bereich",
    "selectCity": "Wählen Sie eine Stadt",
    "sinDisponibilidadTitle": "Derzeit keine Verfügbarkeit",
    "sinDisponibilidadDescription": "Derzeit sind keine Hotels in diesem Reiseziel verfügbar. Wir laden Sie ein, später wiederzukommen oder andere Optionen zu erkunden.",
    "buscarOtroDestino": "Anderes Reiseziel suchen",
    "buscarOtraUbicacion": "Anderen Standort suchen",
    "numRooms": "Anz. Zimmer",
    "ariaLabelHorarioFlexible": "Informationen zum flexiblen Zeitplan",
    "aria": {
      "home": "Startseite",
      "idiomaMoneda": "Sprache und Währung",
      "usuario": "Benutzer",
      "menu": "Menü",
      "favorito": "Favorit",
      "compartir": "Teilen",
      "info": "Information",
      "diaAnterior": "Vorheriger Tag",
      "diaSiguiente": "Nächster Tag",
      "descargarAppIos": "App für iOS herunterladen",
      "descargarAppAndroid": "App für Android herunterladen",
      "showPassword": "Passwort anzeigen",
      "hidePassword": "Passwort verbergen"
    },
    "login": {
      "title": "Willkommen bei BYHOURS",
      "password": "Passwort vergessen?",
      "session": "Anmelden",
      "noAccount": "Haben Sie kein Konto?",
      "registerLabel": "Registrieren",
      "placeholder": {
        "email": "E-Mail-Adresse *",
        "password": "Passwort *"
      },
      "continue": "Weiter",
      "o": "ODER",
      "recover": {
        "title": "Passwort wiederherstellen",
        "subtitle": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts.",
        "subtitle2": "Geben Sie Ihr neues Passwort ein und bestätigen Sie das neue Passwort.",
        "back": "Zurück zur Anmeldung"
      },
      "register": {
        "title": "Erstellen Sie Ihr Konto bei BYHOURS",
        "account": "Haben Sie bereits ein Konto?"
      },
      "google": "Mit Google fortfahren",
      "facebook": "Mit Facebook fortfahren",
      "footer": {
        "user": "Nutzungsvereinbarung",
        "privacy": "Datenschutzrichtlinie",
        "cookies": "Cookie-Richtlinie"
      },
      "emailConfirmation": {
        "title": "Bestätigen Sie Ihre E-Mail-Adresse!",
        "subtitle": "Wir haben eine E-Mail an {email} mit einem Link gesendet, um Ihre E-Mail-Adresse zu bestätigen. Wenn Sie sie nicht in Ihrem Posteingang sehen, überprüfen Sie Ihren Spam-Ordner.",
        "resend": "E-Mail erneut senden"
      },
      "dropdown": {
        "perfil": "Profil",
        "cerrar": "Abmelden"
      }
    },
    "proximaReserva": {
      "titulo": "Nächste Buchung",
      "ver": "Buchung ansehen",
      "repetir": "Buchung wiederholen",
      "repetirSubtitulo": "Vor {days} Tagen",
      "repetirSubtituloHoy": "Heute gebucht",
      "repetirSubtituloAyer": "Gestern gebucht",
      "repetirDescripcion": "Vor {days} Tagen in {hotel} gebucht",
      "repetirDescripcionHoy": "Heute in {hotel} gebucht",
      "repetirDescripcionAyer": "Gestern in {hotel} gebucht"
    },
    "user_zone": {
      "emailVerified": {
        "title": "E-Mail bestätigt",
        "description": "Du kannst den Nutzerbereich jetzt wie gewohnt nutzen."
      },
      "menu": {
        "perfil": "Profil",
        "reservas": "Meine Buchungen",
        "favoritos": "Favoriten",
        "inicio": "Startseite BYHOURS",
        "cerrarSesion": "Abmelden"
      },
      "favoritos": {
        "noFavoritosTitle": "Sie haben noch keine Favoriten",
        "noFavoritosSubtitle": "Worauf warten Sie? Markieren Sie Ihre Lieblingshotels",
        "completeProfile": "Sie müssen Ihr Profil vervollständigen, um Hotels zu Favoriten hinzufügen zu können"
      },
      "perfil": {
        "danger": "Gefahrenzone",
        "deleteAccount": "Konto löschen",
        "deleteAccountText": "Sind Sie sicher, dass Sie Ihr Konto löschen möchten?",
        "deleteAccountText2": "Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden. Alle Ihre Daten werden dauerhaft gelöscht.",
        "successUpdate": "Informationen erfolgreich aktualisiert",
        "successDelete": "Benutzer erfolgreich gelöscht"
      },
      "reservas": {
        "noReservasTitle": "Sie haben noch keine Buchungen",
        "noReservasSubtitle": "Worauf warten Sie? Buchen Sie Ihr Zimmer bei uns",
        "activas": "Aktiv",
        "pasadas": "Vergangen",
        "cancelled": "Storniert",
        "cancel": "Buchung erfolgreich storniert",
        "cancelError": "Fehler beim Stornieren der Buchung",
        "reference": "Referenz",
        "price": "Preis",
        "cancelText": "Sind Sie sicher, dass Sie die Buchung stornieren möchten?",
        "cancelText2": "Wenn Sie jetzt stornieren, könnten Sie Ihre aktuelle Buchung verlieren.",
        "deleteText": "Sind Sie sicher, dass Sie diese Buchung löschen möchten?",
        "deleteText2": "Diese Aktion ist dauerhaft und Sie können die Buchung nicht wiederherstellen.",
        "deleteSuccess": "Buchung erfolgreich gelöscht",
        "deleteError": "Fehler beim Löschen der Buchung",
        "clearHistoryText": "Sind Sie sicher, dass Sie den gesamten Verlauf löschen möchten?",
        "clearHistoryText2": "Alle Ihre vergangenen Buchungen werden dauerhaft ausgeblendet.",
        "clearHistorySuccess": "Verlauf erfolgreich gelöscht",
        "clearHistoryError": "Fehler beim Löschen des Verlaufs",
        "detalle": {
          "titulo": "Buchungsdetails",
          "tiempo": "Aufenthaltsdauer"
        }
      }
    },
    "cancelBook": {
      "title": "Buchung stornieren",
      "subtitle": "Gib deine Buchungsreferenz und die E-Mail-Adresse der Buchung ein. Eine Stornierung ist nur möglich, wenn die Stornierungsbedingungen erfüllt sind (z. B. mindestens 24 Stunden vor dem Check-in).",
      "referenceError": "Bitte Buchungsreferenz eingeben",
      "referencePlaceholder": "Buchungsreferenz",
      "emailPlaceholder": "E-Mail",
      "submit": "Buchung stornieren",
      "success": "Die Buchung wurde erfolgreich storniert",
      "genericError": "Die Buchung konnte nicht storniert werden",
      "backHome": "Zur Startseite"
    },
    "tags": {
      "piscina": "Genießen Sie den Zugang zum Pool, der in Ihrer Buchung enthalten ist! 💦"
    },
    "tooltips": {
      "packHours": "Du kannst {hours}h in diesem Zeitfenster buchen",
      "horarioFlexible": "Ihr Check-in ist flexibel innerhalb der angezeigten Zeit, aber der Check-out muss pünktlich sein."
    },
    "extraHours": {
      "maxExtraHours": "Es können maximal {hours} Zusatzstunden hinzugefügt werden",
      "noExtraHours": "Zu der gewählten Uhrzeit können keine Zusatzstunden hinzugefügt werden"
    },
    "horasDisponibles": "Verfügbare Stunden",
    "gratis": "Kostenlos"
  },
  "errors": {
    "search": "Ein Fehler ist bei der Hotelsuche aufgetreten. Bitte versuchen Sie es erneut.",
    "ubicacion": {
      "support": "Es scheint, dass Ihr Browser die Geolokalisierungsfunktion nicht unterstützt. Versuchen Sie es mit einem anderen Browser oder aktivieren Sie die Option in den Einstellungen.",
      "block": "Der Standort ist in Ihrem Browser blockiert. Um ihn zu aktivieren, gehen Sie zu den Einstellungen und erlauben Sie den Standortzugriff.",
      "permission": "Wir konnten nicht auf Ihren Standort zugreifen, da Sie die Erlaubnis verweigert haben. Sie können sie in den Geräteeinstellungen aktivieren.",
      "gps": "Wir konnten Ihren Standort nicht bestimmen. Stellen Sie sicher, dass GPS aktiviert ist und eine stabile Verbindung besteht.",
      "timeout": "Die Standortanfrage dauert länger als erwartet. Bitte versuchen Sie es in ein paar Augenblicken erneut.",
      "error": "Beim Versuch, Ihren Standort zu ermitteln, ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
    },
    "login": {
      "email": "Ungültige E-Mail",
      "password": "Mindestens 8 Zeichen",
      "passwordComplexity": "Muss mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten",
      "repeatPassword": "Die Passwörter stimmen nicht überein",
      "emailDomain": "Die E-Mail-Domain scheint nicht gültig zu sein",
      "facebook_email_required": "Facebook hat Ihre E-Mail nicht mit uns geteilt. Um sich mit Facebook bei BYHOURS anzumelden, gehen Sie zu Ihren Facebook-App-Einstellungen und gewähren Sie BYHOURS die E-Mail-Berechtigung.",
      "email_verified": "E-Mail bestätigt. Melden Sie sich an, um fortzufahren.",
      "email_verification_failed": "Wir konnten Ihre E-Mail mit diesem Link nicht bestätigen. Wenn sie bereits bestätigt ist, melden Sie sich an. Andernfalls gehen Sie in den Benutzerbereich und senden Sie die E-Mail erneut."
    },
    "user_zone": {
      "delete": "Fehler beim Löschen des Benutzers",
      "password": "Fehler beim Ändern des Passworts",
      "email_verification_failed": "Wir konnten Ihre E-Mail mit diesem Link nicht bestätigen. Wenn sie bereits bestätigt war, wird der Bereich nach dem Aktualisieren freigeschaltet. Andernfalls senden Sie die Bestätigungs-E-Mail erneut."
    }
  },
  "share": {
    "copy": "Link kopieren",
    "whatsapp": "Auf WhatsApp teilen",
    "email": "Per E-Mail teilen",
    "message": "Hallo! Ich teile dieses Hotel mit dir, das ich interessant fand: {url}"
  },
  "checkout": {
    "meta": {
      "title": "Kasse",
      "description": "Schließen Sie Ihre Buchung ab"
    },
    "timer": "Ihr Zimmer ist für {time} Minuten reserviert",
    "steps": {
      "checkinHour": "Check-in-Zeit",
      "data": "Ihre Daten",
      "payment": "Sichere Zahlung",
      "back": "Zurück"
    },
    "sections": {
      "completeCheckinHour": "Wählen Sie die Check-in-Zeit, um fortzufahren"
    },
    "checkinHour": {
      "title": "Check-in-Zeit",
      "subtitle": "Wählen Sie Ihre Ankunftszeit",
      "required": "Wählen Sie eine Check-in-Zeit, um fortzufahren",
      "pendingSummary": "Wählen Sie Ihre Check-in-Zeit",
      "description": "Wählen Sie Ihre Check-in-Zeit innerhalb von {window}; ab dieser Zeit nutzen Sie {hours} Stunden Aufenthalt.",
      "descriptionNoWindow": "Wählen Sie Ihre Check-in-Zeit; ab dieser Zeit nutzen Sie {hours} Stunden Aufenthalt.",
      "placeholder": "Wählen Sie Ihre Check-in-Zeit",
      "changeHour": "Check-in-Zeit ändern",
      "descriptionSelected": "Flexible Anreise ab {checkin}. Ihr Zimmer ist von {checkin} bis {checkout} verfügbar."
    },
    "extras": {
      "title": "Extras",
      "continueWithout": "Ohne Extras fortfahren",
      "noneForHour": "Keine Extras für die gewählte Check-in-Zeit verfügbar"
    },
    "recovery": {
      "title": "Sie haben eine laufende Buchung",
      "finishBooking": "Buchung abschließen",
      "closeAria": "Hinweis schließen"
    },
    "contactData": {
      "title": "Kontaktdaten",
      "loginPrompt": "Haben Sie bereits ein Konto?",
      "loginButton": "Anmelden",
      "registerButton": "Registrieren",
      "loginPromptSuffix": "um Ihre zukünftigen Buchungen zu beschleunigen.",
      "continueAsGuest": "Als Gast fortfahren",
      "firstName": "Vorname",
      "firstNamePlaceholder": "Hans",
      "lastName": "Nachname",
      "lastNamePlaceholder": "Schmidt",
      "email": "E-Mail",
      "emailPlaceholder": "hans.schmidt{'@'}byhours.com",
      "phone": "Telefon",
      "phonePlaceholder": "0151234567",
      "city": "Stadt",
      "cityPlaceholder": "Berlin"
    },
    "promoCode": {
      "title": "Aktionscode",
      "placeholder": "Beispiel: SOMMER10",
      "apply": "Anwenden",
      "applied": "Aktionscode angewendet",
      "remove": "Entfernen",
      "errors": {
        "required": "Geben Sie einen gültigen Aktionscode ein",
        "invalid": "Ungültiger Aktionscode",
        "generic": "Fehler beim Anwenden des Aktionscodes"
      }
    },
    "comments": {
      "title": "Kommentare für das Hotel",
      "placeholder": "Beispiel: 'Ich benötige ein Zimmer mit Rollstuhlzugang'"
    },
    "payment": {
      "title": "Zahlungsmethode"
    },
    "trustBadges": {
      "securePayment": "Sichere Zahlung (Stripe)",
      "freeCancellation": "Kostenlose Stornierung",
      "encryptedData": "Verschlüsselte Daten"
    },
    "terms": {
      "text": "Mit der Buchung akzeptieren Sie unsere",
      "userAgreement": "Nutzungsvereinbarung",
      "privacyText": "Bei BYHOURS verarbeiten wir Ihre persönlichen Daten, um Ihre Buchung zu verwalten und Sie während des gesamten Prozesses auf dem Laufenden zu halten.",
      "privacyInfo": "Weitere Informationen finden Sie in unserer",
      "privacyPolicy": "Datenschutzrichtlinie"
    },
    "buttons": {
      "continue": "Weiter",
      "confirmAndPay": "Bestätigen und jetzt bezahlen",
      "payNow": "Jetzt bezahlen"
    },
    "loading": "Zahlung wird verarbeitet...",
    "summary": {
      "hotel": "Hotel",
      "address": "Adresse",
      "checkIn": "Check-in",
      "checkOut": "Check-out",
      "hotelTaxes": "Hotelsteuern und Gebühren",
      "hotelTaxesTooltip": "Je nach Zielort sind einige Steuern und/oder Gebühren (wie Kurtaxe) möglicherweise nicht im Preis enthalten und müssen direkt im Hotel bezahlt werden",
      "bookingFees": "Buchungsgebühren",
      "bookingFeesTooltip": "Gebühr als Verwaltungskosten",
      "promoDiscount": "Aktionsrabatt",
      "payAtHotel": "Im Hotel zu zahlen",
      "payAtHotelTooltip": "Die Zahlung erfolgt in der Währung der Unterkunft (der Wechselkurs kann variieren)",
      "payNow": "Jetzt zahlst du nur",
      "total": "GESAMT",
      "taxesIncluded": "Steuern und Gebühren inklusive",
      "additionalTaxesSuffix": "zusätzliche Steuern und Gebühren",
      "additionalTaxesBody": "Steuern und Gebühren sind nicht enthalten und werden direkt im Hotel bezahlt",
      "freeCancellation": "Kostenlose Stornierung bis 24 Stunden vor dem Check-in; danach kann das Hotel den vollen Betrag berechnen.",
      "paymentSplit": "Sie zahlen jetzt nur {nowAmount}, den Rest ({hotelAmount}) im Hotel zu zahlen.",
      "seeDetails": "Details ansehen",
      "taxesInfo": "Einige Steuern und/oder Gebühren (wie Kurtaxe) sind möglicherweise nicht im Endpreis enthalten und müssen direkt im Hotel bezahlt werden"
    },
    "paymentDetails": {
      "title": "Zahlungs- und Stornierungsdetails",
      "paymentCharges": {
        "title": "Zahlung und Gebühren",
        "item1": "Die Abbuchung auf Ihrem Konto wird als \"Travel Payment\" angezeigt.",
        "item2": "Sie zahlen jetzt nur einen Teil (Verwaltungsgebühren) und der Rest des Betrags wird direkt im Hotel bezahlt.",
        "item3": "Sie zahlen den gesamten Unterkunftsbetrag im Voraus."
      },
      "cancellations": {
        "title": "Stornierungen und Nichterscheinen",
        "item1": "Sie können Ihre Buchung bis 24 Stunden vor dem Check-in stornieren.",
        "item2": "Wenn Sie rechtzeitig stornieren, erstatten wir Ihnen den gezahlten Betrag.",
        "item3": "Das Hotel behält sich das Recht vor, 100% des Betrags zu berechnen, wenn Sie nicht erscheinen oder außerhalb der Frist stornieren."
      },
      "checkIn": {
        "title": "Check-in",
        "idRequired": "Die Vorlage eines gültigen Ausweisdokuments (Personalausweis oder Reisepass) ist für alle Gäste, die übernachten, Pflicht."
      },
      "support": {
        "title": "Kundenservice",
        "scheduleMondayThursday": "Montag bis Donnerstag von 9 bis 24 Uhr (UTC/GMT +1)",
        "scheduleFriday": "Freitag von 9 bis 21 Uhr (UTC/GMT +1)",
        "scheduleWeekend": "Samstag, Sonntag und Feiertage von 9:30 bis 18:30 Uhr (UTC/GMT +1)",
        "whatsapp": "Sie können uns kontaktieren über",
        "email": "Sie können uns schreiben an:",
        "phones": "Kontakttelefone",
        "uk": "Großbritannien:",
        "france": "Frankreich:",
        "mexico": "Mexiko:",
        "colombia": "Kolumbien:",
        "spain": "Spanien:"
      }
    },
    "errors": {
      "title": "Fehler",
      "firstNameRequired": "Vorname ist erforderlich",
      "lastNameRequired": "Nachname ist erforderlich",
      "emailRequired": "E-Mail ist erforderlich",
      "emailInvalid": "Ungültige E-Mail",
      "phoneInvalid": "Die Telefonnummer darf nur Ziffern enthalten",
      "stripeNotAvailable": "Stripe ist nicht verfügbar",
      "initializePaymentError": "Fehler beim Initialisieren der Zahlung",
      "initializePaymentRetry": "Die Zahlung konnte nicht initialisiert werden. Bitte versuchen Sie es erneut.",
      "clientSecretError": "Client-Secret konnte nicht abgerufen werden",
      "paymentContainerError": "Der Zahlungscontainer ist nach mehreren Versuchen nicht verfügbar",
      "bookingInitError": "Die Buchung konnte nicht initialisiert werden",
      "paymentElementsError": "Zahlungselemente nicht initialisiert",
      "confirmPaymentError": "Fehler beim Bestätigen der Zahlung",
      "paymentIntentError": "Payment Intent konnte nicht abgerufen werden",
      "paymentIncompleteError": "Die Zahlung wurde nicht erfolgreich abgeschlossen. Status: {status}",
      "authenticationFailure": "Die Bankprüfung konnte nicht abgeschlossen werden. Gib die Karte erneut ein. Wenn es weiter fehlschlägt, versuche einen neuen Inkognito-Tab oder die App.",
      "bookingConfirmError": "Fehler beim Bestätigen der Buchung",
      "unexpectedPaymentError": "Unerwarteter Fehler beim Zahlungsvorgang",
      "preBooking": {
        "noAvailability": {
          "title": "Diese Option ist nicht mehr verfügbar",
          "description": "Bitte wählen Sie ein anderes Zimmer im Hotel."
        },
        "hourUnavailable": {
          "title": "Diese Uhrzeit ist nicht mehr verfügbar",
          "description": "Bitte wählen Sie eine andere Check-in-Zeit."
        },
        "retryable": {
          "title": "Wir konnten nicht fortfahren",
          "description": "Bitte versuchen Sie es in einem Moment erneut."
        },
        "network": {
          "title": "Verbindungsproblem",
          "description": "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut."
        },
        "missingData": {
          "title": "Fehlende Angaben",
          "description": "Bitte überprüfen Sie Ihre Kontaktdaten und versuchen Sie es erneut."
        },
        "blacklist": {
          "title": "Buchung nicht möglich",
          "description": "Bitte kontaktieren Sie uns, um fortzufahren."
        },
        "duplicatedBook": {
          "title": "Wir konnten nicht fortfahren",
          "description": "Prüfen Sie Ihre Buchungen oder versuchen Sie es in wenigen Minuten erneut."
        },
        "invalidPromo": {
          "title": "Ungültiger Aktionscode",
          "description": "Entfernen Sie ihn und versuchen Sie es erneut."
        },
        "paymentFailed": {
          "title": "Zahlung konnte nicht gestartet werden",
          "description": "Bitte versuchen Sie es in einem Moment erneut."
        },
        "actions": {
          "changeHour": "Andere Uhrzeit wählen",
          "viewHotel": "Hotel ansehen",
          "retry": "Erneut versuchen",
          "reviewData": "Meine Daten prüfen",
          "removePromo": "Code entfernen und erneut versuchen",
          "myBookings": "Meine Buchungen ansehen"
        }
      }
    }
  },
  "confirm": {
    "meta": {
      "title": "Zahlung erfolgreich",
      "description": "Ihre Buchung wurde bestätigt"
    },
    "header": {
      "title": "Zahlung erfolgreich!",
      "subtitle": "Ihre Buchung wurde bestätigt",
      "reference": "Referenz:"
    },
    "loading": "Zahlung wird überprüft...",
    "personalData": {
      "title": "Persönliche Daten",
      "name": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "phone": "Telefon"
    },
    "location": {
      "title": "Standort"
    },
    "help": {
      "title": "Brauchen Sie Hilfe?"
    },
    "buttons": {
      "viewBookings": "Meine Buchungen anzeigen",
      "searchMore": "Weitere Hotels suchen"
    }
  },
  "onDemandPage": {
    "title": "Keine Verfügbarkeit? Wir kümmern uns darum",
    "subtitle": "Sagen Sie uns, was Sie suchen – unser Team prüft Optionen für Aufenthalte nach Stunden zu Ihrem Ziel und Ihren Daten.",
    "sections": {
      "contact": "Kontaktdaten",
      "trip": "Reiseziel & Daten",
      "additional": "Weitere Angaben"
    },
    "fields": {
      "name": "Name",
      "email": "E-Mail",
      "destination": "Ziel",
      "destinationPlaceholder": "Stadt suchen",
      "checkinDate": "Anreisedatum",
      "checkinTime": "Check-in-Zeit",
      "pack": "Stundenpaket",
      "summary": "Zusammenfassung",
      "attemptedBooking": "Was haben Sie zu buchen versucht?",
      "attemptedPlaceholder": "Hotel, Link oder Details zum gewünschten Aufenthalt"
    },
    "privacy": {
      "checkboxBefore": "Ich akzeptiere die ",
      "link": "Datenschutzerklärung",
      "checkboxAfter": " und die Verarbeitung meiner Daten zur Bearbeitung dieser Anfrage."
    },
    "submit": "Anfrage senden",
    "backHome": "Zur Startseite",
    "success": {
      "title": "Anfrage erhalten",
      "body": "Wir haben Ihre Anfrage erfasst. Wir melden uns so bald wie möglich.",
      "backSearch": "Zur Hotelsuche"
    },
    "errors": {
      "required": "Pflichtfeld",
      "email": "Ungültige E-Mail",
      "privacy": "Sie müssen die Datenschutzerklärung akzeptieren",
      "attemptedMax": "Text zu lang",
      "generic": "Die Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
      "rateLimit": "Zu viele Anfragen. Bitte warte ein paar Minuten und versuche es erneut.",
      "timeOnTheHour": "Bitte eine volle Stunde wählen",
      "validationToastTitle": "Senden nicht möglich",
      "checkinPast": "Check-in-Datum und -Uhrzeit müssen nach dem aktuellen Zeitpunkt liegen.",
      "roomsRange": "Wähle zwischen 1 und 10 Zimmern"
    }
  },
  "strapi": {
    "hotelPage": {
      "descripcion": "Beschreibung",
      "ubicacion": "Lage",
      "servicios": "Dienstleistungen",
      "reserva": "Buchen Sie ein Zimmer",
      "verHabitaciones": "Zimmer anzeigen",
      "preguntas": "Häufig gestellte Fragen",
      "info": "Wichtige Informationen",
      "distance_airport": "Entfernung zum Flughafen",
      "shuttle_service": "Shuttle-Service",
      "shuttle_service_information": "Informationen zum Shuttle-Service",
      "taxi_distance": "Taxi-Entfernung",
      "public_transport": "Öffentlicher Verkehr",
      "noRooms": "Alle verfügbaren Zimmer für dieses Hotel sind am ausgewählten Tag ausgebucht",
      "noRoomsEmpty": {
        "titulo": "Keine Zimmer für dieses Datum",
        "descripcion": "Die Zimmer sind am gewählten Tag ausgebucht. Wählen Sie ein anderes verfügbares Datum."
      },
      "extraDescription": "Wählen Sie Extras aus, um Ihr BYHOURS-Erlebnis zu vervollständigen",
      "extra": {
        "titulo": "Extras",
        "subtitulo": "Extras können nach Auswahl des Zimmers hinzugefügt werden"
      },
      "max_pers": {
        "titulo": "Maximal",
        "subtitulo": "personen"
      },
      "noDispo": {
        "titulo": "Keine Verfügbarkeit in diesem Hotel",
        "subtitulo": "Aktuell keine Verfügbarkeit",
        "descripcionAmigable": "Derzeit keine Verfügbarkeit in diesem Hotel."
      },
      "hotelesCercanos": "Entdecken Sie weitere Hotels in der Nähe"
    },
    "searchPage": {
      "filtroHora": "Check-in Zeit",
      "resultados": "hotels stundenweise in",
      "filtroPack": "Paket",
      "filtroPromo": "Aktion",
      "filtroPrecio": "Preis",
      "filtroEstrella": "Kategorie",
      "filtroServicio": "Dienstleistungen",
      "resultadosAlternativos": "Andere Hotels in anzeigen",
      "resultadosNear": "Hotels in der Nähe von",
      "horasEntrada": "Verfügbare Check-in Zeiten",
      "sinHorasEntrada": "Nicht verfügbar",
      "searchZona": "Diesen Bereich durchsuchen",
      "sinResultados": {
        "titulo": "Oh nein :( Für Ihre Suche sind keine Hotels verfügbar. Versuchen Sie es mit einem anderen Tag, einer anderen Uhrzeit oder einem anderen Reiseziel.",
        "subtitulo": null
      },
      "sinResultadoFiltro": {
        "titulo": "Es gibt keine Hotels mit den ausgewählten Filtern",
        "subtitulo": null
      },
      "sinHoteles": {
        "titulo": "Wie schade! Obwohl Sie bei uns in 600 Städten stundenweise Hotels buchen können, haben Sie ausgerechnet eine auserwählt, in der wir noch keine Angebote verfügbar haben.",
        "subtitulo": null
      },
      "onDemand": {
        "titulo": "Sie finden nicht, wonach Sie suchen?",
        "subtitulo": "Wir haben es in 24 Std. gefunden!"
      },
      "buscandoFechasCercanas": "Verfügbarkeit an anderen Daten wird gesucht…",
      "disponiblesFechasCercanas": "An nahe gelegenen Daten verfügbar in",
      "disponibleEl": "Verfügbar am",
      "probarOtraFecha": "Anderes Datum ausprobieren:",
      "chipManana": "Morgen",
      "chipPasadoManana": "Übermorgen",
      "ordenacion": [
        "Relevanz",
        "Preis (niedriger bis höher)",
        "Preis (höher bis niedriger)",
        "Kategorie (niedriger als höher)",
        "Kategorie (höchste bis niedrigste)"
      ]
    },
    "homePage": {
      "labelHoteles": "Weitere Hotels in"
    },
    "global": {
      "header": {
        "tituloIdioma": "Sprache",
        "tituloMoneda": "Währung",
        "tituloDestinos": "Reiseziele",
        "labelDestinos": "Reiseziele",
        "labelPartners": "Partner",
        "labelAyuda": "Hilfe",
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcelona",
          "berlin": "Berlin",
          "paris": "Paris",
          "roma": "Rom",
          "dubai": "Dubai",
          "bogota": "Bogotá",
          "mexico": "Mexiko-Stadt",
          "lima": "Lima",
          "panama": "Panama-Stadt"
        },
        "buttonDestinos": {
          "label": "Alle Reiseziele anzeigen",
          "link": "destinos",
          "url": false
        },
        "buttonFunciona": {
          "label": "Wie funktioniert es?",
          "link": "como-funciona",
          "url": false
        },
        "buttonPartner": {
          "hoteleros": "Hoteliers",
          "agencias": "Reisebüros"
        },
        "buttonAyuda": {
          "contacto": "Kontakt",
          "preguntas": "Häufig gestellte Fragen"
        }
      },
      "footer": {
        "tituloPrivacidad": "Datenschutz",
        "tituloInformacion": "Information",
        "tituloHoteleros": "Hoteliers",
        "subtituloHoteleros": "Treten Sie BYHOURS bei!",
        "tituloAgencia": "Sind Sie eine Agentur?",
        "subtituloAgencia": "Treten Sie BYHOURS bei!",
        "tituloDestinos": "Einige Reiseziele",
        "tituloSiguenos": "Folgen Sie uns",
        "tituloApp": "Laden Sie die App herunter",
        "keywords": {
          "hotelesPorHoras": "Hotels stundenweise",
          "hotelDeDia": "Tageshotels",
          "habitacionPorHoras": "Zimmer stundenweise"
        },
        "privacidadLinks": {
          "acuerdo": "Benutzervereinbarung",
          "privacidad": "Datenschutzrichtlinie",
          "cookies": "Cookie-Richtlinie"
        },
        "infoLinks": {
          "ayuda": "Hilfe",
          "contacto": "Kontakt",
          "blog": "Blog",
          "unete": "Treten Sie dem Team bei"
        },
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcelona",
          "berlin": "Berlin",
          "paris": "Paris",
          "roma": "Rom",
          "dubai": "Dubai",
          "bogota": "Bogotá",
          "mexico": "Mexiko-Stadt",
          "lima": "Lima",
          "panama": "Panama-Stadt",
          "zurich": "Zürich",
          "viena": "Wien",
          "londres": "London",
          "milan": "Mailand",
          "doha": "Doha",
          "buenosAires": "Buenos Aires",
          "quito": "Quito",
          "santiago": "Santiago de Chile"
        },
        "buttonAgencia": {
          "label": "Zugang zum Portal"
        },
        "buttonHotelero": {
          "label": "Zugang zum Portal"
        },
        "redes": {
          "instagram": "Instagram",
          "facebook": "Facebook",
          "x": "X",
          "linkedin": "Linkedin",
          "tiktok": "Tik Tok",
          "youtube": "Youtube"
        },
        "buttonsApp": {
          "appStore": "App Store",
          "googlePlay": "Google Play"
        }
      }
    }
  },
  "hoteliersPage": {
    "breadcrumb": {
      "home": "Start",
      "current": "Für Hoteliers"
    },
    "hero": {
      "title": "Machen Sie aus leeren Zimmerstunden Umsatz",
      "description": "Vende microestancias en franjas de 3, 6 y 24 horas con las reglas que tú gestiones; franja horaria, disponibilidad y canal propio, sin compromiso de cupo.",
      "cta": "Unserem Hotelnetzwerk beitreten",
      "imageAlt": "BYHOURS für Hoteliers"
    },
    "whyTitle": "Warum BYHOURS",
    "features": [
      {
        "title": "Volle Flexibilität",
        "description": "Steuern Sie die Plattform nach Ihren Vorstellungen: wie und wann Sie Mikroaufenthalte anbieten."
      },
      {
        "title": "Kein Mindestkontingent",
        "description": "Wir verlangen keine Mindestanzahl an Zimmern. Öffnen und schließen Sie die Verfügbarkeit, wann Sie möchten."
      },
      {
        "title": "Differenziertes Produkt",
        "description": "Abgrenzung zur Nachtverkauf: weniger Tarifparitätsprobleme auf Ihren üblichen Kanälen."
      },
      {
        "title": "Zimmerumsatz",
        "description": "Monetarisieren Sie Zeitfenster und Tage, in denen das Zimmer nicht über Nacht verkauft wird."
      },
      {
        "title": "Neue Gästesegmente",
        "description": "Erreichen Sie Geschäftsreisende, Transitgäste und Freizeitreisende, die stundenweise buchen."
      },
      {
        "title": "Keine Bindung",
        "description": "Testen Sie das Modell ohne langfristige Verpflichtung."
      }
    ],
    "whoWeAre": {
      "title": "Wer wir sind",
      "description": "Marktführer für Mikroaufenthalte seit 2012. Kumulierte Kennzahlen und das heutige Netz: internationale Ketten und unabhängige Hotels steigern mit BYHOURS den RevPAR an Hunderten von Destinationen.",
      "ctaQuestion": "Möchten Sie sehen, wie es zu Ihrem Hotel passt?",
      "ctaButton": "Information anfordern"
    },
    "stats": [
      {
        "title": "+15 M€",
        "description": "Für unsere Hotels generiert (kumuliert)"
      },
      {
        "title": "+300 K",
        "description": "Generierte Mikroaufenthaltsbuchungen"
      },
      {
        "title": "+250 K",
        "description": "Zufriedene Kunden"
      },
      {
        "title": "24",
        "description": "Märkte in Europa, Lateinamerika und Naher Osten"
      },
      {
        "title": "+600",
        "description": "Verfügbare Destinationen"
      },
      {
        "title": "+4000",
        "description": "Partnerhotels, die bereits Zusatzerlöse erzielen"
      }
    ],
    "video": {
      "title": "BYHOURS für Ihr Hotel",
      "description": "Erfahren Sie, wie BYHOURS Ihnen hilft, leere Zimmer zu monetarisieren und den Umsatz zu steigern.",
      "iframeTitle": "Video BYHOURS für Hoteliers"
    },
    "widget": {
      "title": "Stundenweise verkaufen auf der eigenen Website",
      "description": "Mit einer Codezeile blendet Ihre Seite einen schwebenden Button ein, der die Stundensuche öffnet: Gäste buchen Mikroaufenthalte sofort, ohne die Umgebung Ihres Hotels zu verlassen.",
      "pillars": [
        {
          "title": "Integration in Minuten",
          "description": "Schlanker Go-live: keine langen Projekte oder Website-Umbauten über das mit Ihrem Team oder Anbieter vereinbarte Snippet hinaus."
        },
        {
          "title": "Stundenbuchung mit einem Klick",
          "description": "Besucher sehen einen schwebenden Button, der den Mikroaufenthalts-Finder öffnet: Sie wählen ein Zeitfenster und schließen die Buchung auf Ihrer Seite ab."
        },
        {
          "title": "Sie behalten die Kontrolle",
          "description": "Preis, Verfügbarkeit und Regeln kommen weiter aus Ihrem BYHOURS-Extranet: Das Widget zeigt nur, was Sie erlauben."
        }
      ],
      "featuresSubtitle": "Widget-Funktionen",
      "widgetFeatures": [
        {
          "title": "Markenfarben und Texte",
          "description": "Primär- und Sekundärfarbe, Button-Radius und CTA-Text anpassen; Finder-Inhalte können Ihren Spracheinstellungen folgen."
        },
        {
          "title": "Schwebend oder eingebettet",
          "description": "Eck-Button oder eingebetteter Block: wählen Sie, was zu Layout und Navigation passt."
        },
        {
          "title": "Unterschiedliche Regeln für Mobil und Desktop",
          "description": "Buttonposition, Abstände und Verhalten getrennt für große und kleine Bildschirme, damit nichts Wichtiges verdeckt wird."
        }
      ],
      "cta": "Integration anfragen",
      "figcaption": "Der schwebende Button öffnet den Mikroaufenthalts-Finder, ohne die Hotelwebsite zu verlassen.",
      "imageAlt": "Beispiel des stundenweisen Buchungswidgets auf einer Hotelwebsite"
    },
    "examples": {
      "title": "Drei reale Kundenbeispiele",
      "description": "Objekte, die bereits mit BYHOURS Mikroaufenthalte abrechnen. Die Zahlen sind Richtwerte je nach Markt und kommerzieller Politik.",
      "benefitLabel": "Nutzen für das Hotel",
      "bookingsLabel": "Buchungen mit BYHOURS",
      "cta": "Ich möchte dem Netzwerk beitreten",
      "cases": [
        {
          "badge": "Barcelona",
          "title": "4-Sterne-Hotel",
          "description": "Gemischter Markt aus Kongressen, Kreuzfahrten und Städtetourismus: Mikroaufenthalte füllen Lücken zwischen Übernachtungen und Last-Minute-Nachfrage in einem umkämpften Umfeld.",
          "revenue": "+700k €",
          "bookings": "+14k"
        },
        {
          "badge": "Madrid",
          "title": "Stadthotel",
          "description": "Hotel ohne Sternkategorie, das den Stundenkanal für Durchreisende, Remote-Arbeit und Kurzaufenthalte nutzt, ohne nur am BAR der Nacht zu konkurrieren.",
          "revenue": "+300k €",
          "bookings": "+7k"
        },
        {
          "badge": "Bogotá",
          "title": "5-Sterne-Hotel",
          "description": "Premium-Profil in einer andinen Hauptstadt: Business, Events und Corporate-Gäste, die Stundenpakete mit engen Terminplänen schätzen.",
          "revenue": "+400k €",
          "bookings": "+12k"
        }
      ]
    },
    "testimonialsTitle": "Das sagen unsere Partner",
    "testimonials": [
      {
        "quote": "Flexibilität bei Preis und Last-Minute-Verfügbarkeit hilft uns, den ADR in Zeitfenstern zu verbessern, die früher leer blieben.",
        "name": "Juan Reyna",
        "role": "Director of Sales & Marketing — Hilton Barcelona",
        "kind": "hilton"
      },
      {
        "quote": "In einem Markt, in dem Gäste immer vielseitiger sind, ermöglicht uns eine Lösung wie BYHOURS, eine Zielgruppe anzusprechen, die nicht immer ein passendes Angebot findet. Zudem macht eine einfach zu bedienende Plattform mit voller Kontrolle und Flexibilität die Erzielung von Zusatzerlösen so einfach wie nie zuvor.",
        "name": "Xavier Micó",
        "role": "General Manager — Four Points by Sheraton",
        "kind": "marriott"
      },
      {
        "quote": "Die BYHOURS-Plattform bietet eine innovative und flexible Lösung, damit Hotels ihre Zimmerauslastung maximieren. Besonders hervorzuheben ist, dass Zimmer nicht nur für volle Tage (24 h), sondern auch für 3 oder 6 Stunden angeboten werden können. Das eröffnet neue Möglichkeiten, Leerstände zu reduzieren und Zusatzerlöse zu erzielen.\n\nDas Extranet überzeugt insgesamt: übersichtlich, intuitiv und mit einfacher, effizienter Verwaltung der Inserate. Auch ohne lange Einarbeitung findet man sich zügig zurecht und nutzt die wichtigsten Funktionen problemlos.\n\nEin weiteres Plus ist der Kundenservice: Anfragen werden schnell bearbeitet und stets freundlich und professionell beantwortet. Man fühlt sich gut betreut und unterstützt – die Zusammenarbeit ist besonders angenehm. Insgesamt ist BYHOURS eine durchdachte, moderne Plattform, die mit Funktionalität und exzellentem Service überzeugt.",
        "name": "Robert Franke",
        "role": "Channelmanagement Coordinator — GHC Hotels",
        "kind": "ghc"
      },
      {
        "quote": "BYHOURS ist zu einem unverzichtbaren Werkzeug für unseren Tagesbetrieb geworden. Es bietet maximale Flexibilität bei Verfügbarkeit, Preisen, individuellen Paketen und vollständiger Kontrolle über die Vertriebsstrategie – für eine sofortige Anpassung an Marktschwankungen, Stornierungen, vorzeitige Abreisen usw.\n\nDie Auswirkungen auf den Umsatz waren sehr positiv: Wir haben einen deutlichen Anstieg der Einnahmen erzielt. Die intuitive Oberfläche, die volle Flexibilität und der hervorragende Kundenservice erleichtern die Abläufe erheblich, verkürzen die Bearbeitungszeit und minimieren operative Fehler.\n\nDerzeit ist BYHOURS eine unverzichtbare Ergänzung für unser Hotel.",
        "name": "Anonym",
        "role": "Hotelpartner",
        "kind": "anonymous"
      }
    ],
    "demand": {
      "title": "Ihr Hotel erreicht diese Nachfrageprofile",
      "description": "So buchen Stunden-Gäste, die Ihr Hotel suchen: Diese Segmente zu bedienen steigert Belegung und Umsatz über das reine Übernachtungsmuster hinaus.",
      "items": [
        {
          "title": "Business und Arbeit",
          "paragraph": "Berufstätige, die WLAN, eine Pause zwischen Terminen oder Ruhe außerhalb des Büros brauchen. Sie buchen Tageszeitfenster, die zu Ihrem Bestand zwischen den Nächten passen."
        },
        {
          "title": "Reisende",
          "paragraph": "Passagiere mit Anschlussflügen, Verspätungen oder langen Wartezeiten: Dusche, Ruhe und Komfort nahe Flughafen oder Bahnhof. Ihr Hotel deckt ein Bedürfnis ab, das die Nacht allein nicht immer löst."
        },
        {
          "title": "Lifestyle und Freizeit",
          "paragraph": "Spa, Pool oder Terrasse vor oder nach Konzerten, Shopping oder urbanen Wochenenden. Sie binden Freizeitnachfrage ein, die nur die genutzten Stunden zahlen will."
        }
      ]
    },
    "steps": {
      "title": "Wie werde ich Teil von BYHOURS?",
      "description": "Mit BYHOURS zu verdienen ist einfach. In drei Schritten monetarisieren Sie leere Zimmer.",
      "items": [
        {
          "title": "Registrierung",
          "description": "Füllen Sie das Formular aus, wir melden uns bei Ihnen.",
          "linkToForm": true
        },
        {
          "title": "Schulung",
          "description": "In einem kurzen Onboarding laden Sie erste Verfügbarkeit und lernen die Plattform kennen.",
          "linkToForm": false
        },
        {
          "title": "Verkauf",
          "description": "Ihr Hotel ist live: Sie verkaufen und monetarisieren leere Zimmer mit BYHOURS.",
          "linkToForm": false
        }
      ]
    },
    "form": {
      "title": "Werden Sie Teil unseres Hotelnetzwerks",
      "description": "Senden Sie Ihre Anfrage – wir melden uns schnellstmöglich, um Ihr Hotel und die nächsten Schritte zu besprechen. Die Angaben dienen nur der Beantwortung Ihrer Anfrage; Verantwortlicher: BYHOURS Travel S.L.",
      "successTitle": "Anfrage gesendet",
      "successDescription": "Vielen Dank. Wir haben Ihre Nachricht erhalten und melden uns schnellstmöglich.",
      "hotelSection": "Hoteldaten",
      "contactSection": "Kontakt",
      "hotelName": "Hotelname",
      "website": "Website (optional)",
      "rooms": "Zimmeranzahl",
      "roomsPlaceholder": "Bereich wählen…",
      "cityCountry": "Standort des Hotels",
      "cityPlaceholder": "Stadt suchen…",
      "contactName": "Kontaktperson",
      "email": "E-Mail",
      "phone": "Telefon",
      "comments": "Kommentare (optional)",
      "commentsPlaceholder": "Beschreiben Sie Ihr Anliegen: Zusammenarbeit, Widget-Integration, kommerzielle Fragen …",
      "privacyBefore": "Ich akzeptiere die ",
      "privacyLink": "Datenschutzerklärung",
      "privacyAfter": " und die Verarbeitung meiner Daten zur Beantwortung dieser Anfrage.",
      "submit": "Anfrage senden",
      "websitePlaceholder": "https://hotel.example.com"
    },
    "faq": {
      "title": "Fragen?",
      "description": "Antworten auf häufige Fragen von Revenue Managern und Vertriebsteams.",
      "items": [
        {
          "label": "Was ist ein Mikroaufenthalt?",
          "content": "Eine Hotelbuchung für 3, 6 oder 24 Stunden, bei der der Gast die Check-in-Zeit am Tag wählt. Sie steuern Preis und Verfügbarkeit pro Zeitfenster."
        },
        {
          "label": "Gibt es ein Mindestkontingent oder eine Bindung?",
          "content": "Wir verlangen weder Mindestzimmer noch Laufzeit. Sie können das Modell testen und bei Bedarf anpassen."
        },
        {
          "label": "Wirkt es sich auf BAR oder Yield aus?",
          "content": "Das Produkt ist eine eigene Linie für andere Segmente (Business, Transit, Last Minute) und füllt Lücken, ohne den Nachtverkauf zu ersetzen."
        },
        {
          "label": "Wie werden Zeitfensterpreise festgelegt?",
          "content": "Sie legen Tarife und Mikroaufenthaltsregeln im Extranet mit der Flexibilität Ihrer Strategie fest. Unser Team unterstützt Sie beim Start."
        },
        {
          "label": "Gibt es Provisionen oder Umsatzbeteiligung?",
          "content": "Die kommerziellen Konditionen (Provisionen, Abrechnungen) werden beim Eintritt ins Partnerprogramm vereinbart. Wir erläutern sie im ersten Gespräch nach Ihrer Anfrage."
        },
        {
          "label": "Lässt es sich mit PMS oder Channel Manager integrieren?",
          "content": "Wir prüfen Integrationen nach Ihrem Stack. Nennen Sie Ihre Systeme im Formular oder im Welcome-Call – wir finden die beste Option."
        },
        {
          "label": "Wie läuft die Abrechnung für Gast und Hotel?",
          "content": "BYHOURS kassiert beim Gast gemäß Ihrem Partnervertrag; Abrechnung und Auszahlungen erläutern wir im Onboarding."
        },
        {
          "label": "Was brauche ich zum Start?",
          "content": "Füllen Sie das Formular auf dieser Seite aus. Unser Team begleitet Sie bei Einrichtung und erster Veröffentlichung der Verfügbarkeit im Extranet."
        }
      ]
    },
    "toast": {
      "validationTitle": "Bitte Formular prüfen"
    },
    "errors": {
      "server": "Senden fehlgeschlagen. Bitte erneut versuchen.",
      "rateLimit": "Zu viele Anfragen. Bitte warte ein paar Minuten und versuche es erneut."
    },
    "validation": {
      "hotelName": "Hotelnamen angeben",
      "websiteMax": "Website-URL zu lang",
      "rooms": "Zimmerbereich wählen",
      "cityCountry": "Stadt und Land angeben",
      "contactName": "Kontaktnamen angeben",
      "emailRequired": "E-Mail angeben",
      "emailInvalid": "Ungültige E-Mail",
      "phone": "Telefonnummer angeben",
      "commentsMax": "Maximal 4000 Zeichen",
      "privacy": "Sie müssen die Datenschutzerklärung akzeptieren"
    },
    "roomRanges": [
      {
        "label": "1 – 9",
        "value": "1-9"
      },
      {
        "label": "10 – 19",
        "value": "10-19"
      },
      {
        "label": "20 – 59",
        "value": "20-59"
      },
      {
        "label": "60 – 99",
        "value": "60-99"
      },
      {
        "label": "100 oder mehr",
        "value": "100+"
      }
    ]
  }
}
